
export class CookieConsent {
    private baseElement: HTMLElement;
    private toggleDetailsBtn: HTMLInputElement;
    private acceptAllBtn: HTMLInputElement;
    private declineAllBtn: HTMLInputElement;
    private acceptSelectionBtn: HTMLInputElement;
    private allowMarketingCheckbox: HTMLInputElement;
    private allowAnalyticsCheckbox: HTMLInputElement;
    private allowPerformanceCheckbox: HTMLInputElement;
    private selectionContainer: HTMLElement;

    constructor() {
        this.initElements();
    }

    public init(): void{
        this.registerToggleDetailsBtnListener();
        this.registerAcceptAllBtnListener();
        this.registerAcceptSelectionBtnListener();
        this.registerDeclineAllBtnListener();
    }

    private initElements() {
        this.baseElement = document.querySelector('[data-component=CookieConsent]');
        this.toggleDetailsBtn = <HTMLInputElement>this.baseElement.querySelector(`button[id='toggle-details-btn']`);
        this.acceptAllBtn = <HTMLInputElement>this.baseElement.querySelector(`button[id='accept-all-btn']`);
        this.declineAllBtn = <HTMLInputElement>this.baseElement.querySelector(`button[id='decline-all-btn']`);
        this.acceptSelectionBtn = <HTMLInputElement>this.baseElement.querySelector(`button[id='accept-selection-btn']`);
        this.allowAnalyticsCheckbox = <HTMLInputElement>this.baseElement.querySelector(`input[id='allow-analytics-check']`);
        this.allowMarketingCheckbox = <HTMLInputElement>this.baseElement.querySelector(`input[id='allow-marketing-check']`);
        this.allowPerformanceCheckbox = <HTMLInputElement>this.baseElement.querySelector(`input[id='allow-performance-check']`);
        this.selectionContainer = <HTMLElement>this.baseElement.querySelector(`div[class='allow-selection-container']`)
    }

    private registerToggleDetailsBtnListener() {
        this.toggleDetailsBtn.addEventListener('click', async () => {
            if(this.selectionContainer.style.display != "block"){
                this.selectionContainer.style.display = "block";
                this.acceptSelectionBtn.style.display = "inline-block";
                this.acceptAllBtn.style.display = "none";
            }else {
                this.selectionContainer.style.display = "none";
                this.acceptAllBtn.style.display = "inline-block";
                this.acceptSelectionBtn.style.display = "none";
            }
        });
    }

    private registerAcceptAllBtnListener() {
        this.acceptAllBtn.addEventListener('click', async () => {
            document.cookie = this.acceptAllBtn.dataset.cookieString;
            document.cookie = this.buildAllowedCookieTypesString('Functional|Marketing|Tracking|Performance');
            this.reloadPage();
        });
    }

    private registerDeclineAllBtnListener() {
        this.declineAllBtn.addEventListener('click', async () => {
            document.cookie = this.declineAllBtn.dataset.cookieString;
            document.cookie = this.buildAllowedCookieTypesString('Functional');
            this.reloadPage();
        });
    }

    private registerAcceptSelectionBtnListener() {
        this.acceptSelectionBtn.addEventListener('click', async () => {
            document.cookie = this.acceptAllBtn.dataset.cookieString;
            var selection = this.getAllowedCookiesSelection();
            document.cookie = this.buildAllowedCookieTypesString(selection);
            this.reloadPage();
        });
    }
    
    private reloadPage(){
        sessionStorage.removeItem('first-visitor-popup-disable');
        window.location.reload();
    }

    private getAllowedCookiesSelection(): string {
        var selection: string[] = ['Functional'];

        if (this.allowMarketingCheckbox.checked)
            selection.push('Marketing');

        if (this.allowAnalyticsCheckbox.checked)
            selection.push('Tracking');

        if (this.allowPerformanceCheckbox.checked)
            selection.push('Performance');

        return selection.join('|').toString();
    }

    private buildAllowedCookieTypesString(types: string): string {
        return `AllowedCookies=${types}; expires=${this.getAllowedTypesCookieExpiration()}; path=/; samesite=Lax`;
    }

    private getAllowedTypesCookieExpiration(): string {
        const d = new Date();
        d.setTime(d.getTime() + (365 * 24 * 60 * 60 * 1000));
        return `expires=${d.toUTCString()}`;
    }
}
